import gql from 'graphql-tag';
import { STORY_TYPE } from './StoryType.gql';

export const DELETE_STORY = gql`
  ${STORY_TYPE}
  mutation deleteStory($id: ID!) {
    deleteStory(id: $id) {
      story {
        ...StoryType
      }
    }
  }
`;
